/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const NFCCardPage = lazyLoad(
  () => import('./index'),
  module => module.NFCCardPage,
);
